<template>
  <div
    class="orm-datepicker"
    :class="{ 'datepicker__mapModule orm-row': viewType == 'mapModule' }"
    v-click-outside="handleClick"
  >
    <div
      :class="{
        'orm-datecol orm-pr-sm-8': viewType !== 'mapModule',
        'orm-datecol--map orm-col-xs-12': viewType == 'mapModule',
      }"
    >
      <div class="orm-searchbar__headline" v-if="viewType !== 'infobar'">
        <strong>{{ i18n("general/pickup") }}</strong>
      </div>
      <div class="orm-dateselect orm-row no-margin">
        <div class="orm-col-xs-6 orm-col-md-6 orm-px-8">
          <div>
            <small>{{ i18n("general/date") }}</small>
          </div>
          <div
            class="orm-datepicker__input orm-pr-16"
            @click="changeDate = 'start'"
            id="start"
            :class="[
              changeDate == 'start' ? 'active' : '',
              station ? 'enable' : 'disable',
            ]"
          >
            {{
              formateDateShort(
                store.getters["userSession/GET_RESERVATIONDATE"].start
              )
            }}
            <i class="fal fa-calendar-alt"></i>
          </div>
        </div>
        <div class="orm-col-xs-6 orm-col-md-6 orm-px-8">
          <div>
            <div>
              <small>{{ i18n("general/time") }}</small>
            </div>
            <div v-if="station">
              <timepicker
                v-if="openingSelctedStart"
                :endtime="false"
                :selected="openingSelctedStart"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        'orm-datecol orm-pl-sm-8': viewType !== 'mapModule',
        'orm-datecol--map orm-col-xs-12': viewType == 'mapModule',
      }"
    >
      <div class="orm-searchbar__headline" v-if="viewType !== 'infobar'">
        <strong>{{ i18n("general/delivery") }}</strong>
      </div>
      <div class="orm-dateselect orm-row no-margin">
        <div class="orm-col-xs-6 orm-col-md-6 orm-px-8">
          <div>
            <small>{{ i18n("general/date") }}</small>
          </div>
          <div
            class="orm-datepicker__input orm-pr-16"
            @click="changeDate = 'end'"
            id="end"
            :class="[
              changeDate == 'end' ? 'active' : '',
              station ? 'enable' : 'disable',
            ]"
          >
            {{
              formateDateShort(
                store.getters["userSession/GET_RESERVATIONDATE"].end
              )
            }}
            <i class="fal fa-calendar-alt"></i>
          </div>
        </div>
        <div class="orm-col-xs-6 orm-col-md-6 orm-px-8">
          <div>
            <div>
              <small>{{ i18n("general/time") }}</small>
            </div>
            <div v-if="station">
              <timepicker
                v-if="openingSelctedStart"
                :endtime="true"
                :selected="openingSelctedEnd"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-range-selector
      v-if="changeDate"
      v-model:start-date="
        store.getters['userSession/GET_RESERVATIONDATE'].start
      "
      v-model:end-date="store.getters['userSession/GET_RESERVATIONDATE'].end"
      v-model:changeDate="changeDate"
      :disabled-start-dates="disabledStartDates"
      :disabled-end-dates="disabledEndDates"
      :min-start-date="minDateStart"
      :min-end-date="minDateEnd"
      :max-start-date="maxDateStart"
      :max-end-date="maxDateEnd"
      :default-date="store.getters['userSession/GET_RESERVATIONDATE'].start"
      :disabledWeekdays="disabledWeekdays"
      :singleMonth="viewType == 'mapModule' ? true : false"
      :lang="lang"
      @update:startDate="changeStart"
      @update:endDate="changeEnd"
    />
  </div>
</template>

<script>
import VRangeSelector from "@/components/vuelendar/vl-range-selector";
import timepicker from "@/components/ui/timepicker.vue"; // @ is an alias to /src
import store from "@/store";
import i18n from "@/mixins/mixins";

import {
  formateDate,
  formatDayOfWeek,
  formateDateShort,
} from "@/constants/formater";

export default {
  components: {
    VRangeSelector,
    timepicker,
  },
  mixins: [i18n],
  setup() {
    return {
      formateDateShort,
      formatDayOfWeek,
      store,
    };
  },
  data() {
    return {
      range: Object,
      pickerRange: Object,
      date: null,
      minDateStart: null,
      minDateEnd: null,
      maxDateStart: null,
      maxDateEnd: null,
      station: null,
      disabledStartDates: [],
      disabledEndDates: [],
      disabledWeekdays: [],
      schedule: null,
      changeDate: null,
      openingStartMin: null,
      openingEndMin: null,
      openingSelctedStart: null,
      openingSelctedEnd: null,
      endtimeconfig: null,
      starttimeconfig: null,
      lang: "DE",
    };
  },
  props: {
    viewType: String,
    vDatepickerTeleport: String,
    infobar: {
      type: Boolean,
      default: false,
    },
    isOffer: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    // console.log(this.isOffer);
    const crentReservation = document.getElementById("crentReservation");
    if (crentReservation) {
      if (crentReservation.dataset) {
        if (crentReservation.dataset.lang) {
          this.lang = crentReservation.dataset.lang;
        }
      }
    }

    this.range = await store.getters["userSession/GET_RESERVATIONDATE"];

    const station = await store.getters["userSession/GET_STATION"];
    this.disabledStartDates = store.getters["stations/GET_CLOSEDSTARTDAYS"];
    this.disabledEndDates = store.getters["stations/GET_CLOSEDENDDAYS"];

    // console.log("disabledStartDates", this.disabledStartDates);
    // console.log("disabledEndDates", this.disabledEndDates);

    if (station) {
      this.station = await store.getters["stations/GET_STATION_BY_ID"](station);
      this.initStartEndDate();
    }

    if (this.isOffer) {
      await store.dispatch("stations/SET_OPENINGTIMES").then(() => {
        this.setOpeneningTimes();
      });
    }

    store.watch(
      (state, getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
        this.initStartEndDate();
      }
    );

    store.watch(
      (state, getters) => getters["stations/GET_CLOSEDSTARTDAYS"],
      (val) => {
        this.disabledStartDates = val;
      }
    );

    store.watch(
      (state, getters) => getters["stations/GET_CLOSEDENDDAYS"],
      (val) => {
        this.disabledEndDates = val;
      }
    );

    store.watch(
      (state, getters) => getters["stations/GET_OPENINGTIMES"],
      (val) => {
        if (val) {
          this.setOpeneningTimes();
        }
      }
    );

    // store.watch(
    //   (state, getters) => getters["stations/GET_CLOSEDDAYS"],
    //   (val) => {
    //     this.disabledDates = val;
    //   }
    // );
  },
  methods: {
    handleClick(ev) {
      if (!ev.target.classList.contains("vl-calendar__arrow")) {
        this.changeDate = null;
      }
    },
    changeStart(event) {
      this.pickerRange.start = event;
      store.commit("userSession/MUTATE_DATE", this.pickerRange);
      this.range = store.getters["userSession/GET_RESERVATIONDATE"];

      store.dispatch("stations/SET_OPENINGTIMES").then(() => {
        this.setOpeneningTimes();
      });
    },
    changeEnd(event) {
      this.pickerRange.end = event;
      store.commit("userSession/MUTATE_DATE", this.pickerRange);
      this.range = store.getters["userSession/GET_RESERVATIONDATE"];
      store.dispatch("stations/SET_OPENINGTIMES").then(() => {
        this.setOpeneningTimes();
      });
    },
    // eslint-disable-next-line
    initStartEndDate() {
      this.setOpeneningTimes();
    },
    async setOpeneningTimes() {
      const openeningTimes = await store.getters["stations/GET_OPENINGTIMES"];
      this.schedule = openeningTimes;

      this.range = await store.getters["userSession/GET_RESERVATIONDATE"];
      this.pickerRange = { start: this.range.start, end: this.range.end };

      if (openeningTimes) {
        this.openingSelctedStart =
          this.station.id + ":" + openeningTimes.selected_start_date;
        this.openingSelctedEnd =
          this.station.id + ":" + openeningTimes.selected_end_date;

        this.openingStartMin = openeningTimes.min_start_date.split("T");
        this.openingEndMin = openeningTimes.min_end_date.split("T");
        this.minDateStart = formateDate(openeningTimes.min_start_date);
        this.minDateEnd = formateDate(openeningTimes.min_end_date);
        this.maxDateStart = formateDate(openeningTimes.max_start_date);
        this.maxDateEnd = formateDate(openeningTimes.max_end_date);

        this.endtimeconfig = openeningTimes.end_time_config;
        this.starttimeconfig = openeningTimes.start_time_config;
      }
    },
  }
};
</script>
